<div class="p-2">
    <div class="card skill-card">
        <div class="skill-card-header">
            {{ technicalSkill.header }}
        </div>
        <div class="skill-card-content form-control" *ngFor="let skill of technicalSkill.skills">
            <a [href]="skill.link">
                {{ skill.displayName }}
            </a>
            <img [src]="skill.logo" [alt]="skill.displayname">
        </div>
    </div>
</div>